<template>
	<div>
		<el-form ref="form" :model="form" :rules="rules" label-width="120px" style="width: 600px;">
			<el-form-item label="角色名称" prop="name">
				<el-input v-model="form.name" placeholder="请输入角色名称"></el-input>
			</el-form-item>
			<el-form-item label="角色编码" prop="code">
				<el-input v-model="form.code" placeholder="请输入角色编码"></el-input>
			</el-form-item>
			<el-form-item label="角色描述" prop="description">
				<el-input type="textarea" v-model="form.description" placeholder="请输入角色描述"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button @click="$router.back()">取消</el-button>
				<el-button type="primary" @click="handleSave">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { add, edit, detail } from "@/api/permission/role";
export default {
	data() {
		return {
			id: null,
			form: {
				name: "",
				code: "",
				description: ""
			},
			rules: {
				name: [{ required: true, message: '请输入角色名称' }],
				code: [{ required: true, message: '请输入角色编码' }],
			}
		}
	},
	mounted() {
		this.id = this.$route.query.id;
		if (this.id) {
			this.getDetail();
		}
	},
	methods: {
		getDetail() {
			detail(this.id).then(({ code, data }) => {
				if (code == 200) {
					this.form = {
						name: data.name,
						code: data.code,
						description: data.description
					};
				}
			})
		},
		handleSave() {
			this.$refs.form.validate(valid => {
				if (!valid) return;
				const params = {
					...this.form
				}
				if (!this.id) {
					add(params).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("添加成功");
							this.$router.back();
						} else {
							this.$message.error(message);
						}
					})
				} else {
					params.id = this.id;
					edit(params).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("修改成功");
							this.$router.back();
						} else {
							this.$message.error(message);
						}
					})
				}
			})
		}
	}
}
</script>

<style></style>